import Page from "../pages/layout/espFramePage";

export default [
  {
    path: "/task_query",
    name: "task_query",
    redirect: "/task_query/index",
    component: Page,
    children: [
      {
        path: "index",
        name: "task_query_index",
        meta: {title: "任务查询", isIndex: true, keepAlive: true},
        component: () => import("@/pages/task/job_query/index")
      }
    ]
  },
  {
    path: "/task_plan",
    name: "task_plan",
    redirect: "/task_plan/index",
    component: Page,
    children: [
      {
        path: "index",
        name: "task_plan_index",
        meta: {title: "任务计划", isIndex: true, keepAlive: true},
        component: () => import("@/pages/task/plan/index")
      }
    ]
  },

  {
    path: "/task_job",
    name: "task_job",
    redirect: "/task_job/index",
    component: Page,
    children: [
      {
        path: "index",
        name: "task_job_index",
        meta: {title: "任务管理", isIndex: true, keepAlive: true},
        component: () => import("@/pages/task/job/index")
      }
    ]
  },
  {
    path: "/task_plan_child",
    name: "task_plan_child",
    redirect: "/task_plan_child/index",
    component: Page,
    children: [
      {
        path: "index",
        name: "task_plan_child_index",
        meta: {title: "子任务计划", isIndex: true, keepAlive: true},
        component: () => import("@/pages/task/plan_child/index")
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/task.js